import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/modelStore.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";
import { combine, guard, merge, restore, createEvent } from 'effector';
import { sortByString } from '@gmini/utils';
import * as api from '@gmini/sm-api-sdk';
import { buildIdVersionKey } from "../DependencyTree/model";
import { adapter } from "../../classifier-service/adapters";
import { selectedModels } from "./selectedModels";
export function createModelStoreService(getViewerId) {
  var resetDependenciesWithModels = createEvent({
    name: "resetDependenciesWithModels",
    sid: "fz3tp3"
  });
  var dependenciesWithModels$ = restore(merge([api.DependencyWithModels.getClassifierDependencyModels.defaultContext.doneData, api.DependencyWithModels.getAssemblyDependencyModels.defaultContext.doneData], {
    name: "dependenciesWithModels$",
    sid: "-ene4ae"
  }) // сортировка классификаторов по имени
  .map(function (response) {
    return sortByString(response.dependencyModels, function (_ref) {
      var classifier = _ref.classifier;
      return classifier.name;
    });
  }) // сортировка моделей в классификаторах по имени
  .map(function (dependencies) {
    return dependencies.map(function (dep) {
      return _objectSpread(_objectSpread({}, dep), {}, {
        models: sortByString(dep.models, function (model) {
          return model.name;
        })
      });
    });
  }).map(function (dependencies) {
    return dependencies.map(function (dep) {
      return _objectSpread(_objectSpread({}, dep), {}, {
        models: dep.models
      });
    });
  }), [], {
    name: "dependenciesWithModels$",
    sid: "-sfj150"
  });
  dependenciesWithModels$.reset(resetDependenciesWithModels); //TODO FSK-682 - Frontend: вынести стор selectedModels$ из репы вьювера, избавить classifierEditor от оставшихся зависимостей viewer'а

  var selectedModel$ = combine({
    ɔ: [selectedModels.models$, dependenciesWithModels$, function (selectedModels, classifiersWithModels) {
      if (!(selectedModels !== null && selectedModels !== void 0 && selectedModels.length)) {
        return null;
      }

      var allModels = classifiersWithModels.reduce(function (acc, classifier) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(classifier.models));
      }, []);
      var models = allModels.reduce(function (acc, next) {
        var model = selectedModels.some(function (model) {
          var _next$viewerRefs;

          return (_next$viewerRefs = next.viewerRefs) === null || _next$viewerRefs === void 0 ? void 0 : _next$viewerRefs.some(function (viewerRef) {
            return model.viewerId === getViewerId(adapter(next), viewerRef);
          });
        });

        if (next && model) {
          acc[buildIdVersionKey({
            id: next.id,
            version: next.version
          })] = next;
        }

        return acc;
      }, {});
      return models;
    }],
    config: {
      name: "selectedModel$",
      sid: "-i289p7"
    }
  });
  var allModels$ = dependenciesWithModels$.map(function (deps) {
    return deps.reduce(function (acc, dep) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(dep.models));
    }, []);
  }); // Если модель не существует то сбрасываем стор

  guard({
    ɔ: [{
      source: combine({
        ɔ: [[allModels$, selectedModel$], function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              allModels = _ref3[0],
              selectedModel = _ref3[1];

          return !allModels.some(function (_ref4) {
            var id = _ref4.id,
                version = _ref4.version;
            return selectedModel && selectedModel[buildIdVersionKey({
              id: id,
              version: version
            })];
          });
        }],
        config: {
          name: "source",
          sid: "2b1mpa"
        }
      }),
      target: selectedModels.reset,
      filter: Boolean
    }],
    config: {
      sid: "-ewrj43"
    }
  });
  return {
    dependenciesWithModels$: dependenciesWithModels$,
    selectedModel$: selectedModel$,
    resetDependenciesWithModels: resetDependenciesWithModels
  };
}